import { __assign } from '../../node_modules/tslib/tslib.es6.js';
import { jsx } from 'react/jsx-runtime';
import './index.scss.js';
import classNames from 'classnames';
import { DEFAULT_GUTTER } from '../const.js';

var MasonryColumn = function (props) {
    var children = props.children, columnCount = props.columnCount, _a = props.className, className = _a === void 0 ? "" : _a, _b = props.style, style = _b === void 0 ? {} : _b, _c = props.gutter, gutter = _c === void 0 ? DEFAULT_GUTTER : _c;
    return (jsx("div", __assign({ className: classNames(["masonry-column-wrap", className]), style: __assign(__assign({}, style), { columnGap: gutter, columnCount: columnCount }) }, { children: children })));
};

export { MasonryColumn as default };
